let React = require("react");
let CircuitsUtil = require("../../../util/CircuitsUtil.js");
let AssetDetailsLink = require("../AssetDetailsLink.jsx");
let ContentServerClient = require("../../../ContentServerClient.js");


class View3DModelButton extends React.Component  {
    constructor(){
        super()

        this.state = { modelID: false };
        this.requestError = false;
    }

    componentDidMount() {
        const { resource, handleError } = this.props;

        let version = CircuitsUtil.getMostRecentVersion(resource);

        if(version != -1) { 

            ContentServerClient.getColabDocVersion(handleError, "packages", resource.id, version)
                    .then(res => {
                        let body = res.body;
                        let model = body.model3d;
                        if(!model) return;
                        
                        let $class = model.$class;
                        let assetId = model.assetId;

                        if($class === "Model3DReference"){
                            let modelID = assetId;
                            this.setState({modelID});
                        }
                    })
        }
    }


    render(){
        const { modelID } = this.state;
        const { id } = this.props.resource;
        let noModelFound = modelID === false;
        return <AssetDetailsLink 
                    {...this.props}
                    Content={()=>"View 3D Model"}
                    mainClass="button"
                    removeDisable={noModelFound}
                    objUrl={{ pathname: `/3dmodels/${modelID}`}} // it would be nice to be able to give current view here to return to,
                                                                // but our router cannt 'stack' modals (yet) (TODO)!
               />
    }
}

module.exports = View3DModelButton;